import * as React from "react";

import {
  OriginThemeProvider,
  TrackingProvider,
} from "@origin-digital/ods-core";
import { trackingProviderCaptureClick } from "@origin-digital/reporting-client";

import { NoNavigationHeader } from "@/components/NoNavigationHeader";

import { ErrorWrapper } from "./components/ErrorWrapper";
import { ToastContextProvider } from "./context/ToastContext";
import AppRouters from "./routes";
import ScrollRestoration from "@/ScrollToTop";

export const Root: React.FC = () => (
  <div data-id="microsite-electrify">
    <OriginThemeProvider>
      <TrackingProvider onTrackingCapture={trackingProviderCaptureClick}>
        <ErrorWrapper>
          <ToastContextProvider>
            <NoNavigationHeader />
            <ScrollRestoration>
              <AppRouters />
            </ScrollRestoration>
          </ToastContextProvider>
        </ErrorWrapper>
      </TrackingProvider>
    </OriginThemeProvider>
  </div>
);
